import type { FC } from 'react';

import { RadixTypography } from '../../typography';
import type { StepDetails } from './Stepper';

export interface StepDescriptionInterface extends StepDetails {
	children: string;
}

export const StepDescription: FC<StepDescriptionInterface> = ({ children }) => {
	return (
		<RadixTypography
			variant="default"
			className="grey-500"
		>
			{children}
		</RadixTypography>
	);
};
